:host {
  --submenu-width: #{rem(15)};
  /* stylelint-disable-next-line max-line-length */
  --adjustable-padding: min(var(--cxs-spacer-xl), calc((99.5vw - (2 * var(--cxs-spacer-l)) - (var(--submenu-width) * 4)) / 5));
  display: flex;
  block-size: 100%;
}

.main-link {
  --button-border-radius: 0;
  display: flex;
  grid-row-start: 2;
  color: var(--cxsShell_TextColor);
  font: var(--cxsShell_NavigationFont);

  &::part(element),
  .link {
    padding: calc(var(--cxsShell_MenuSpaceBetween) / 2);
    outline: none;
  }

  a.link:hover:not(:active),
  &:hover:not(:active) {
    color: var(--cxsShell_Hover_TextColor);
  }

  &__content,
  a.link {
    display: flex;
    line-height: rem(1.0625); //17px;
    white-space: nowrap;
  }

  &--focused {
    &::part(element),
    .link {
      outline: 2px solid var(--cxsContent_FocusColor);
      outline-offset: var(--cxs-spacer-xxs);
    }
  }
}

.has-submenu-wrapper {
  block-size: 100%;
}

.has-submenu {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  position: relative;
  box-sizing: border-box;
  margin: 0;
  block-size: 100%;

  &.open {
    .main-link {
      color: var(--cxsShell_Active_TextColor);
    }

    .underline {
      @include underline;
    }
  }
}

.submenu-list {
  @include popover;
  display: none;
  position: absolute;
  flex-flow: column;
  margin: 0;
  padding-block: var(--cxs-spacer-l) var(--cxs-spacer-xl);
  padding-inline: var(--cxs-spacer-xl);
  row-gap: var(--cxs-spacer-l);

  // display: flex for hidden submenu to calculate correct position (left and right offsets in the calculateTranslateX method)
  &--hidden {
    display: flex;
    visibility: hidden;
  }

  &--open {
    display: flex;
    visibility: visible;
  }

  .icon-wrapper {
    margin-inline-start: var(--cxs-spacer-xs);
  }

  &__divider {
    position: absolute;
    inline-size: calc(var(--submenu-width) / 3);
    border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
  }

  &__deep-link {
    font: var(--cxsShell_MenuFont);

    .link {
      padding-block: calc(var(--cxs-spacer-s) / 2);
    }
  }
}

.display-title {
  margin-block-end: var(--cxs-spacer-m);
  color: var(--cxsShell_MenuTextColor);
  font: var(--cxsShell_MenuTitleFont);
  text-align: center;
}

.submenu-list--explore {
  inset-inline-start: calc(var(--cxs-header-wrapper-inline-maring) * -1);
  box-sizing: border-box;
  inline-size: calc(100% + var(--cxs-header-wrapper-inline-maring) * 2);
  min-block-size: rem(42.75);
  padding-block: var(--cxs-spacer-l) var(--cxs-spacer-xl);
  padding-inline: 0;
  box-shadow: var(--cxsShell_MenuBoxShadow);

  // hide explore menu with display:none because it may provide unnecessary scroll on a page with low height.
  // we can't do it for other menus because we need visibility:hidden to calc their position before opening
  &.submenu-list--hidden {
    display: none;
  }

  &.submenu-list--open {
    display: flex;
  }
}

.submenu-list--adjustable {
  padding-block: var(--cxs-spacer-l) var(--cxs-spacer-xl);
  padding-inline: var(--adjustable-padding);
}

[data-mode='light'] {
  .has-submenu {
    margin-inline: calc(var(--cxsShell_MenuSpaceBetween) / 2);
  }

  .main-link::part(element),
  .link {
    padding-inline: 0;
  }

  .has-submenu--explore {
    margin: 0;
    margin-inline: calc(var(--cxsShell_MenuSpaceBetween) / 2) 0;
  }

  .submenu-list--explore {
    .display-title {
      margin: 0;
    }
  }

  .submenu-list__deep-link .link {
    padding-block: rem(.5) rem(.5);
    padding-inline: rem(.5) rem(.75);
    display: block;
  }
}
